import {createStyles, Group, Stack, Text} from '@mantine/core';
import React from 'react';

import type {ListingViewHeader} from 'llm/chat-library/shared/list-detail/listDetailTypes';

const useStyles = createStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: 0,
    overflow: 'hidden',
  },
  header: {
    padding: `${theme.spacing.lg} ${theme.spacing.md} ${theme.spacing.none}`,
  },
  scroll: {
    flex: '1 1 auto',
    minHeight: 0,
    overflowY: 'auto',
    padding: theme.spacing.md,
  },
}));

export function ChatSettingsPaneHeader({header}: {header: ListingViewHeader}): JSX.Element {
  const {classes} = useStyles();

  return (
    <Stack spacing="xs" className={classes.header}>
      <Group noWrap={true} position="apart" align="center">
        <Text fw="bold" size="xl">
          {header.title}
        </Text>
        {header.action}
      </Group>
    </Stack>
  );
}

export default function ChatSettingsPane({
  header,
  scrollable = true,
  children,
}: {
  header?: ListingViewHeader;
  /** When true (default) the children render inside a scrolling region. */
  scrollable?: boolean;
  children: React.ReactNode;
}): JSX.Element {
  const {classes} = useStyles();

  return (
    <div className={classes.root}>
      {header != null && <ChatSettingsPaneHeader header={header} />}
      {scrollable ? <div className={classes.scroll}>{children}</div> : children}
    </div>
  );
}
